import { render } from "./place.vue?vue&type=template&id=691771cf&scoped=true"
import script from "./place.vue?vue&type=script&lang=js"
export * from "./place.vue?vue&type=script&lang=js"

import "./place.vue?vue&type=style&index=0&id=691771cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691771cf"]])

export default __exports__